import { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext();

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("authToken"));
  const [role, setRole] = useState(() => localStorage.getItem("authRole"));
  const [username, setUsername] = useState(() => localStorage.getItem("authUsername"));

  const login = useCallback(async (usernameInput, password) => {
    const res = await axios.post(`${API}/auth/login`, {
      username: usernameInput,
      password,
    });
    const { token: t, role: r, username: u } = res.data;
    localStorage.setItem("authToken", t);
    localStorage.setItem("authRole", r);
    localStorage.setItem("authUsername", u);
    setToken(t);
    setRole(r);
    setUsername(u);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authRole");
    localStorage.removeItem("authUsername");
    setToken(null);
    setRole(null);
    setUsername(null);
  }, []);

  const getAuthHeaders = useCallback(() => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  }, [token]);

  return (
    <AuthContext.Provider
      value={{
        token,
        role,
        username,
        login,
        logout,
        getAuthHeaders,
        isAuthenticated: !!token,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
